import { render, staticRenderFns } from "./InOrderLayout.vue?vue&type=template&id=15fbd46b&scoped=true&"
import script from "./InOrderLayout.vue?vue&type=script&lang=ts&"
export * from "./InOrderLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InOrderLayout.vue?vue&type=style&index=0&id=15fbd46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbd46b",
  null
  
)

export default component.exports